import React from 'react';
// - MENU ICONS
import plansIcon from 'assets/icons/menu-icons/plan.svg';
import permissionsIcon from 'assets/icons/menu-icons/permission.svg';
import patientsIcon from 'assets/icons/menu-icons/patients.png';
import branchIcon from 'assets/icons/menu-icons/branch.svg';
import healthInsuranceIcon from 'assets/icons/menu-icons/health-insurance.svg';
import attendanceIcon from 'assets/icons/menu-icons/attedance.svg';
import usersIcon from 'assets/icons/menu-icons/users.png';
import clientsIcon from 'assets/icons/menu-icons/clients.svg';
import doctorsIcon from 'assets/icons/menu-icons/doctor.svg';
//import notificationsIcon from 'assets/icons/menu-icons/notification.svg';
// import nursingTechniciansIcon from 'assets/icons/menu-icons/nursing-assistant.svg';
// import nursingAssistantsIcon from 'assets/icons/menu-icons/nursing-technician.svg';
// import dashboardIcon from 'assets/icons/menu-icons/dashboard.png';
import visitsDashboardIcon from 'assets/icons/menu-icons/visits-dashboard.svg';
import locationIcon from 'assets/icons/menu-icons/location.svg';
import evaluationIcon from 'assets/icons/menu-icons/report.svg';
import medicalKit from 'assets/icons/menu-icons/medical-kit.svg';
import nandaIcon from 'assets/icons/menu-icons/nanda.svg';
import padMenuIcon from 'assets/icons/menu-icons/padMenuIcon.svg';
import pepIcon from 'assets/icons/menu-icons/pep.svg';

// permissions
import { GROUPS, /* CENE_CLIENT_ID, */ ACCESS } from 'app/config/consts';
import { MENU } from 'app/config/mainMenu';
import HealthProfessional from 'app/components/pages/health-professional/HealthProfessional';

//import { toUpper } from 'lodash';

// - ROUTES COMPONENTS
const Users = React.lazy(() => import('app/components/pages/users/Users'));
const Clients = React.lazy(() => import('app/components/pages/clients/Clients'));
const Permissions = React.lazy(() => import('app/components/pages/permissions/Permissions'));
const Patients = React.lazy(() => import('app/components/pages/patients/Patients'));
const PatientDetail = React.lazy(() => import('app/components/pages/patient-detail/PatientDetail'));
// const Visitation = React.lazy(() => import('app/components/pages/visits/Visitation'));
const Visitation = React.lazy(() => import('app/components/pages/visits/Visitation'));
const VisitsInitialAssessment = React.lazy(() =>
  import('app/components/pages/visits/visits-initial-assessment/VisitsInitialAssessment')
);
/* const LinkProfessional = React.lazy(() =>
  import('../../components/pages/visits/link-professional')
); */
const VisitationDetail = React.lazy(() => import('app/components/pages/visit-detail'));
/*
const Notifications = React.lazy(() =>
  import('app/components/pages/notifications/Notifications')
);
*/
const HealthInsurance = React.lazy(() =>
  import('app/components/pages/health-insurance/HealthInsurance')
);

const ElectronicHealthRecord = React.lazy(() =>
  import('app/components/pages/pep-menu/ElectronicHealthRecord')
);

const Pep = React.lazy(() => import('app/components/pages/pep-menu/Pep'));

// const Dashboard = React.lazy(() => import('app/components/pages/dashboard/Dashboard'));
const VisitDashboard = React.lazy(() =>
  import('app/components/pages/visit-dashboard/VisitDashboard')
);
const PlanVisitForm = React.lazy(() => import('app/components/pages/visit-form/PlanVisitForm'));
const NotFound = React.lazy(() => import('app/components/pages/notfound/NotFound'));
const ProfessionalAvailability = React.lazy(() =>
  import('app/components/pages/professional-availability/ProfessionalAvailability')
);
const Routing = React.lazy(() => import('app/components/pages/routing/Routing'));
const RoutingMap = React.lazy(() => import('app/components/pages/routing/RoutingMap'));
const Monitoring = React.lazy(() => import('app/components/pages/monitoring/Monitoring'));
// const PadMonitoring = React.lazy(() =>
//   import('app/components/pages/pad-menu/pad-monitoring/PadMonitoring')
// );
const BusinessPartner = React.lazy(() =>
  import('app/components/pages/business-partner/BusinessPartner')
);

const Cid = React.lazy(() => import('app/components/pages/cid/Cid'));

const Kit = React.lazy(() => import('app/components/pages/item/kit/Kit'));
const KitMatMed = React.lazy(() => import('app/components/pages/item/kit/KitMatMed'));
const Equipment = React.lazy(() => import('app/components/pages/item/equipment/Equipment'));
const MatMed = React.lazy(() => import('app/components/pages/item/matMed/MatMed'));
const NandaDomain = React.lazy(() => import('app/components/pages/nanda-domain/NandaDomain'));
const NandaClass = React.lazy(() => import('app/components/pages/nanda-class/NandaClass'));
const NandaDiagnostic = React.lazy(() =>
  import('app/components/pages/nanda-diagnostic/NandaDiagnostic')
);
const Attendances = React.lazy(() => import('app/components/pages/attendances/Attendances'));

// const EvaluationForm = React.lazy(() => import('app/components/pages/evaluation/EvaluationForm'));

const Profession = React.lazy(() => import('app/components/pages/profession/Profession'));

// PAD
const PadCreator = React.lazy(() => import('app/components/pages/pad-menu/pad-creator/PadCreator'));
const PadEditor = React.lazy(() => import('app/components/pages/pad-menu/pad-editor/PadEditor'));
const ReschedulePad = React.lazy(() =>
  import('app/components/pages/pad-menu/reschedule-pad/ReschedulePad')
);
const PadDashboard = React.lazy(() => import('app/components/pages/pad-dashboard/PadDashboard'));
const PadMenu = React.lazy(() => import('app/components/pages/pad-menu'));
const PrescritpionMenu = React.lazy(() =>
  import('app/components/pages/prescription-menu/PrescriptionMenu')
);
const Pad = React.lazy(() => import('app/components/pages/pad-menu/pad/Pad'));
const Item = React.lazy(() => import('app/components/pages/item/Item'));
const Procedure = React.lazy(() => import('app/components/pages/procedures/Procedure'));
const Evaluation = React.lazy(() => import('app/components/pages/evaluation/Evaluation'));
const ServiceProducts = React.lazy(() =>
  import('app/components/pages/service-products/ServiceProducts')
);
const PreviewEvaluation = React.lazy(() =>
  import('app/components/pages/preview-evaluation/PreviewEvaluation')
);
const AdministrationRoute = React.lazy(() =>
  import('app/components/pages/administration-route/AdministrationRoute')
);
const InitializeClient = React.lazy(() =>
  import('app/components/pages/pad-menu/initialize-pad/initialize-client')
);
const InitializeCooperative = React.lazy(() =>
  import('app/components/pages/pad-menu/initialize-pad/initialize-cooperative')
);

const Report = React.lazy(() =>
  import('app/components/pages/reports/extension-report/PageExtensionReport')
);

const ReportConfiguration = React.lazy(() =>
  import('app/components/pages/reports/report-configuration/ReportConfiguration')
);

const ReportGeneration = React.lazy(() =>
  import('app/components/pages/reports/report-generation/ReportGeneration')
);

const ReportProductivity = React.lazy(() =>
  import('app/components/pages/reports/report-productivity/ReportProductivity')
);

// const ScheduleCooperativeVisit = React.lazy(() =>
//   import('app/components/pages/pad-menu/schedule-cooperative-visit/ScheduleCooperativeVisit')
// );

/*const KitProcedure = React.lazy(() =>
  import('app/components/pages/procedures/KitProcedure')
);*/

const Branch = React.lazy(() => import('app/components/pages/branch/Branch'));

const VisitationType = React.lazy(() =>
  import('app/components/pages/visitation-type/VisitationType')
);

const SignSymptom = React.lazy(() => import('app/components/pages/sign-symptom/SignSymptom'));

const HealthSandardsReports = React.lazy(() =>
  import('app/components/pages/reports/health-standards-reports/HealthStandardsReports')
);

const ROUTES = [
  {
    exact: true,
    path: '/visit-dashboard',
    component: VisitDashboard,
    image: visitsDashboardIcon,
    title: 'Painel de Visitas',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.VISIT
  },
  // {
  //   exact: true,
  //   path: '/schedule-cooperative-visit/pad/:id',
  //   component: ScheduleCooperativeVisit,
  //   canAccess: [
  //     GROUPS.SALVUS_ADMIN,
  //     GROUPS.GROUP_ADMIN,
  //     GROUPS.GROUP_DEFAULT
  //     // GROUPS.BUSINESS_PARTNER,
  //   ],
  //   whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  // },
  {
    /* EXPLANATION
      Devido à lentidão do sistema a página principal passou a ser
      de Listagem de Visita ,
    */
    exact: true,
    path: '/',
    component: Visitation,
    image: plansIcon,
    title: 'Lista',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.VISIT
  },
  {
    /* EXPLANATION
      Devido à lentidão do sistema a página principal passou a ser
      de Listagem de Visita ,
    */
    exact: true,
    path: '/visitation',
    component: Visitation,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/professional-availability',
    component: ProfessionalAvailability,
    image: visitsDashboardIcon, //calendarVisitsIcon,
    title: 'Disponibilidade de profissional',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/visitation-type',
    component: VisitationType,
    image: visitsDashboardIcon,
    title: 'Tipos de Visita',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/professional-visit/detail/:id',
    component: VisitationDetail,
    image: patientsIcon,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/visits-initial-assessment/:id',
    component: VisitsInitialAssessment,
    image: patientsIcon,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  /* {
    exact: true,
    path: '/link-professional/:id',
    component: LinkProfessional,
    image: patientsIcon,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  }, */
  {
    exact: true,
    path: '/pad-creator',
    component: PadCreator,
    image: padMenuIcon,
    title: 'CRIAÇÃO DE PADS',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/pad-editor/:id',
    component: PadEditor,
    image: padMenuIcon,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/reschedule-pad/:id',
    component: ReschedulePad,
    image: padMenuIcon,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/pad-dashboard',
    component: PadDashboard,
    image: padMenuIcon,
    title: 'PAINEL DOS PADS',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/pad',
    component: PadMenu,
    image: padMenuIcon,
    title: 'Lista de PADs',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/prescription-menu',
    component: PrescritpionMenu,
    image: padMenuIcon,
    title: 'Painel de Prescrições',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/pad/:id',
    component: Pad,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/item',
    component: Item,
    image: medicalKit,
    title: 'Itens',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/procedures',
    component: Procedure /*KitProcedure,*/,
    image: patientsIcon,
    title: 'Procedimentos',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/evaluation-type',
    component: Evaluation,
    image: evaluationIcon,
    title: 'Avaliações',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  // {
  //   exact: true,
  //   path: '/evaluation-type/:id',
  //   component: EvaluationForm,
  //   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
  //   whoCanAccess: [ACCESS.CLIENT]
  // },
  {
    exact: true,
    path: '/service-product',
    component: ServiceProducts,
    image: patientsIcon,
    title: 'Produtos',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/initialize-pad/:id',
    component: InitializeClient,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/bind-professional/:id',
    component: InitializeCooperative,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/pad-monitoring/:id',
    component: Monitoring,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  // {
  //   exact: true,
  //   path: '/pad-monitoring/:id',
  //   component: PadMonitoring,
  //   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
  //   whoCanAccess: [ACCESS.CLIENT]
  // },
  {
    exact: true,
    path: '/patients',
    component: Patients,
    image: patientsIcon,
    title: 'Pacientes',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/patients/:id',
    component: PatientDetail,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/attendance',
    component: Attendances,
    image: attendanceIcon,
    title: 'Atendimento',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/health-professional',
    component: HealthProfessional,
    image: doctorsIcon,
    title: 'Profissionais de Saúde',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/sign-symptom',
    component: SignSymptom,
    image: patientsIcon,
    title: 'Sinais e Sintomas',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.TERMINOLOGY
  },
  {
    exact: true,
    path: '/preview-evaluation',
    component: PreviewEvaluation,
    image: patientsIcon,
    title: 'Prévia de Avaliação',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/administration-route',
    component: AdministrationRoute,
    image: patientsIcon,
    title: 'Vias de Administração',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/pep',
    component: ElectronicHealthRecord,
    image: pepIcon,
    title: 'Prontuário Eletrônico',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PEP
  },
  {
    exact: true,
    path: '/pep/:id',
    component: Pep,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },

  {
    exact: true,
    path: '/routing',
    component: Routing,
    image: locationIcon,
    title: 'Roteirização',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/routing/:id',
    component: RoutingMap,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/profession',
    component: Profession,
    image: doctorsIcon,
    title: 'Profissões',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/equipment',
    component: Equipment,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/mat-med',
    component: MatMed,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/kit',
    component: Kit,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/kit-mat-med/kit/:id',
    component: KitMatMed,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/cid',
    component: Cid,
    image: plansIcon,
    title: 'CID',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.TERMINOLOGY
  },
  // {
  //   exact: true,
  //   path: '/report/productivity',
  //   component: ReportProductivity,
  //   image: patientsIcon,
  //   title: 'Produtividade',
  //   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
  //   whoCanAccess: [ACCESS.CLIENT],
  //   section: MENU.REPORT
  // },

  {
    exact: true,
    path: '/configuration',
    component: ReportConfiguration,
    image: patientsIcon,
    title: 'Configuração',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/report-productivity',
    component: ReportProductivity,
    image: patientsIcon,
    title: 'Produtividade',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/visit-report',
    component: Report,
    image: patientsIcon,
    title: 'Visita',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/health-sandards-reports',
    component: HealthSandardsReports,
    image: patientsIcon,
    title: 'Padrões de Saúde',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/generation',
    component: ReportGeneration,
    image: patientsIcon,
    title: 'Emissão em Massa',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/nanda-diagnostic',
    component: NandaDiagnostic,
    image: nandaIcon,
    title: 'Diagnóstico Nanda',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.TERMINOLOGY
  },
  {
    exact: true,
    path: '/nanda-class',
    component: NandaClass,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/nanda-domain',
    component: NandaDomain,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/users',
    component: Users,
    image: usersIcon,
    title: 'Usuários',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/business-partner',
    component: BusinessPartner,
    image: healthInsuranceIcon,
    title: 'Parceiro de Negócio',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/health-insurance',
    component: HealthInsurance,
    image: healthInsuranceIcon,
    title: 'Operadoras',
    // title: 'Plano de Saúde',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.HEALTH_PLAN
  },
  {
    exact: true,
    path: '/permissions',
    component: Permissions,
    image: permissionsIcon,
    title: 'Permissões',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.USERS
  },
  /*
  {
    exact: true,
    path: '/notifications',
    component: Notifications,
    image: notificationsIcon,
    title: 'Notificações',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.HEALTH_PLAN,
  },
  */
  {
    exact: true,
    path: '/clients',
    component: Clients,
    image: clientsIcon,
    title: 'Clientes',
    canAccess: [GROUPS.SALVUS_ADMIN],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.HEALTH_PLAN
  },
  {
    exact: true,
    path: '/plan-visit',
    component: PlanVisitForm,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/branch',
    component: Branch,
    image: branchIcon,
    title: 'Filiais',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.BRANCH
  },
  {
    exact: false,
    path: '*',
    component: NotFound,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  }
];

/*function isMenuVisible(route, account) {
  return route.title !== undefined &&
    route.canAccess.length &&
    route.section !== undefined
    ? route.canAccess.indexOf(account.groupId) !== -1
    : route.canAccess === account.groupId;
}
*/
// /**
//  *
//  * @param {*} account
//  */
// export function getRoutes(account) {
//   if (CENE_CLIENT_ID.includes(account.clientId)) {
//     return ROUTES.filter(
//       r => r.grupoCene === true || r.grupoCene === undefined
//     );
//   } else {
//     return ROUTES.filter(r => r.grupoCene !== true);
//   }
// }

/**
 *
 * @param {*} account
 */
export function getRoutes(account) {
  const { groupId, businessPartnerId } = account;

  const groupFilter = ROUTES.filter(r => r.canAccess.includes(groupId));

  if (businessPartnerId !== null)
    return groupFilter.filter(r => r.whoCanAccess.includes(ACCESS.BUSINESS_PARTNER));

  return groupFilter;
}

// export function getMenu(account) {
//   return ROUTES.filter(r => isMenuVisible(r, account));
// }

export function getMenu(account) {
  return getRoutes(account);

  // return ROUTES.filter(r => isMenuVisible(r, account));
}
